import{useContext as e}from"react";import{DataLakeContext as a}from"../DataLakeContext.js";const o=()=>{const t=e(a);if(!t)throw new Error("useDataLakeContext must be used within a DataLakeProvider");return t};export{o as useDataLakeContext};
//# sourceMappingURL=useDataLakeContext.js.map
